<loading-indicator [running]="loading$ | async" />

<wound-care-list [items]="items$ | async" (details)="goToDetails($event)" (pictures)="openSlideshow($event)" />
